<div class="mdw-date-time-picker-card">
  <div class="vflex-000">
    <div class="pad-300 hflex-100 flex-align-items-center flex-justify-content-space-between">
      <div class="hflex-150 flex-align-items-center">
        <mdw-icon class="small-icon" [icon]="icons.Calendar_Fill"></mdw-icon>
        <p class="bold">{{ dateLabel() }}</p>
      </div>
      <label class="toggle-label">
        <input
          type="checkbox"
          toggle
          data-pw="date-toggle"
          [attr.aria-label]="dateLabel()"
          [checked]="dateEnabled()"
          (change)="toggleDate()"
        />
        <span class="extra-small secondary">{{ dateEnabled() ? 'On' : 'Off' }}</span>
      </label>
    </div>

    <mdw-collapse [isCollapsed]="!dateEnabled()">
      <div class="calendar-wrapper">
        <mdw-calendar
          size="small"
          [value]="date()"
          (valueChange)="date.set($event)"
          [startAt]="startAt()"
          [filterType]="filterType()"
        ></mdw-calendar>
      </div>
    </mdw-collapse>
  </div>

  <mdw-collapse [isCollapsed]="!dateEnabled()">
    <div class="vflex-000 border-muted-top">
      <div class="pad-300 hflex-100 flex-align-items-center flex-justify-content-space-between">
        <div class="hflex-150 flex-align-items-center">
          <mdw-icon class="small-icon" [icon]="icons.Time_Fill"></mdw-icon>
          <p class="bold">{{ timeLabel() }}</p>
        </div>
        <label class="toggle-label">
          <input
            type="checkbox"
            toggle
            data-pw="time-toggle"
            [attr.aria-label]="timeLabel()"
            [checked]="timeEnabled()"
            (change)="toggleTime()"
          />
          <span class="extra-small secondary">{{ timeEnabled() ? 'On' : 'Off' }}</span>
        </label>
      </div>

      <mdw-collapse [isCollapsed]="!timeEnabled()">
        <div class="time-wrapper">
          <mdw-time-input
            size="small"
            [showLabel]="false"
            [value]="time() ?? undefined"
            (valueChange)="onTimeChange($event)"
          ></mdw-time-input>
        </div>
      </mdw-collapse>
    </div>
  </mdw-collapse>
</div>
